<div class="opt-dialog-container">
  <div class="header">
    <h1 mat-dialog-title>Email Confirmation</h1>
  </div>

  <div mat-dialog-content>
    <form *ngIf="!isLoading" [formGroup]="confirmForm">
      <span
        >We've sent email with confirmation code to
        <strong>{{ confirmation.email }}</strong></span
      >
      <mat-label
        ><label for="confirmationCode">Confirmation code</label></mat-label
      >
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <input
          matInput
          type="text"
          formControlName="confirmationCode"
          id="confirmationCode"
          cdkFocusInitial
          maxlength="6"
        />
      </mat-form-field>
      <mat-error *ngIf="codeError"
        >Confirmation code invalid or expired</mat-error
      >
    </form>
    <div *ngIf="isLoading" class="empty">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <div mat-dialog-actions>
    <button
      mat-flat-button
      type="button"
      (click)="onCancel()"
      [disabled]="isLoading"
    >
      Cancel
    </button>
    <button
      mat-flat-button
      color="primary"
      (click)="onSubmit()"
      [disabled]="submitDisabled || isLoading"
    >
      <span>Submit</span>
    </button>
  </div>
</div>
